import {
  FcColor,
  FcColorGradient,
  FcColorTransparent,
  FcPercentageSize,
  FcShape,
  FcText
} from './fc_common.types'
import { FcContainerFragmentOptions, FcGeneratorOptions } from './fc_generator.types'

export interface FcContainer {
  shape: FcShape
  text?: FcText[]
  borderColor: FcColor
  borderOutlineColor?: FcColor
  borderOutlineSize?: number
  borderSize: number
  borderGradient?: FcColorGradient
  outerPatternColor: FcColor
  outerPatternShape: FcShape
  outerPatternImageUrl?: string | null
  backgroundColor: FcColor
  dataGridPercentageSize: FcPercentageSize
  containerImageUrlFillSvg?: boolean | null
  containerImageUrl?: string | null
  containerImageUrlFg?: string
  containerImageUrlOpacity?: number
  containerImageUrlFgOpacity?: number
  containerImageOverlayPrivacy?: boolean
  containerImageBackgroundOnly?: boolean
  rimWidth?: FcPercentageSize
  rimText?: FcText[]
  rimPatternSpacing?: FcPercentageSize
  rimImageUrl?: string | null
  rimImageUrlOpacity?: number
  rimBackgroundColor?: FcColor
  rimBorderColor?: FcColor
  rimBorderSize?: number
  rimOutlineColor?: FcColor
  rimOutlineSize?: number
  rimBorderGradient?: FcColorGradient
  rimPatternColorFillSvg?: boolean
  rimPatternColor?: FcColor
  rimPatternShape?: FcShape
  rimPatternImageUrl?: string | null
  rimPatternSize?: FcPercentageSize
  borderInsetEyes?: FcPercentageSize
  backgroundInsetExtend?: FcPercentageSize
  borderInsetCalcValue: number
  borderIntersections?: number[][]
  privacyTextPaddingHorizontal?: number
  privacyTextPaddingVertical?: number
  containerSquareRadius: number
  useCmyk: boolean
  fragmentRadiusMask?: number
  overlayRadiusMask?: number
  overlayExpandTargetSize?: boolean
  fragments?: FcContainerFragmentOptions[]
  fragmentGradient?: FcColorGradient
  dataCheckOnly?: boolean
  maskImageUrl?: string | null
  containerColorGradient?: FcColorGradient
}

export function fcContainerIsCustom(container: FcContainer): boolean {
  if (container.containerImageBackgroundOnly) {
    return false
  }
  return !!(container.containerImageUrl || container.fragments)
}

export function fcContainerIsCustomerFromOpts(opts: FcGeneratorOptions): boolean {
  if (opts.containerImageBackgroundOnly) {
    return false
  }
  return !!(opts.containerImageUrl || opts.containerFragments)
}

export function getRimIndent(container: FcContainer): number {
  let rimIndent = 0
  if (container.rimWidth || container.rimBorderSize) {
    if (!container.rimWidth) {
      container.rimWidth = 0
      container.rimBackgroundColor = FcColorTransparent
    }
    if (!container.rimBorderSize) {
      container.rimBorderSize = 0
    }
    if (!container.rimOutlineSize) {
      container.rimOutlineSize = 0
    }
    rimIndent = container.rimWidth + container.rimBorderSize
  }
  return rimIndent
}
